import { url } from '../../axios/api_urls/feedback'
const api = require('../../axios/request')

const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
const state = {
  options: {
    moduleList: [],
    commentModuleList: [],
    group: [],
    role: [],
    userList: []
  }
}
const getters = {
  options: state => state.options
}
const mutations = {
  [UPDATE_OPTIONS] (context, payload) {
    context.options[payload.key] = payload.value
  }
}
const actions = {
  getCommentList(context, payload){
    return api._post(url.commentList, payload)
  },
  getCommentDetail(context, payload){
    return api._post(url.commentDetail, payload)
  },
  submitFeedback(context, payload){
    return api._post(url.submit, payload)
  },
  getFeedbackList(context, payload){
    return api._post(url.list, payload)
  },
  getModuleList({commit}, payload){
    return api._post(url.module, {parentId: 0}).then(res => {
      commit(UPDATE_OPTIONS, {key: 'moduleList', value: res.data || []})
    })
  },
  getCommentModuleList({commit}, payload){
    return api._post(url.commentModule, {parentId: 262}).then(res => {
      commit(UPDATE_OPTIONS, {key: 'commentModuleList', value: res.data || []})
    })
  },
  getRole({commit}, payload = ''){
    return api._post(url.findFilterRoles, {keyword: payload, status: 2, current: 1, size: 100 }).then(res => {
      commit(UPDATE_OPTIONS, {key: 'role', value: res.data || []})
    })
  },
  changeCommentDisplay({commit}, payload = {}) {
    return api._post(url.changeCommentDisplay, payload )
  },
  getCommentApproveStatus({commit}, payload = {}) {
    return api._post(url.getCommentApproveStatus, payload )
  },
  changeCommentApprove({commit}, payload = {}) {
    return api._post(url.changeCommentApprove, payload )
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/feedback.js